import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { TextField, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/bmw");
    } catch (err) {
      alert("Erreur login");
    }
  };

  return (
    <section className="sectionLogin">
      <Container maxWidth="xs">
        <TextField
          fullWidth
          label="Email"
          margin="normal"
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          fullWidth
          type="password"
          label="Mot de passe"
          margin="normal"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button fullWidth variant="contained" onClick={handleLogin}>
          Login
        </Button>
      </Container>
    </section>
  );
}
